import styled from '@emotion/styled';

export const FooterText = styled.div<{ hasReviews: boolean }>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: ${(props) => (props.hasReviews ? '50%' : 'auto')};
`;

export const ReviewWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  max-height: 19px;
`;

export const ReviewText = styled.div`
  font-size: 14px;
  margin-left: 4px;
  font-weight: 400;
`;
